"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDFPreview = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var mobile_1 = require("@caddigital/sok-ui/lib/utils/mobile");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var isSupported = function (name) {
    if (navigator.userAgent.indexOf('MSIE')) {
        try {
            var obj = new ActiveXObject(name);
            return true;
        }
        catch (e) {
            return false;
        }
    }
    else {
        name = name.toLowerCase();
        var plugins = window.navigator.plugins;
        for (var i = 0, len = plugins.length; i < len; i++) {
            if (plugins[i].name.toLowerCase().indexOf(name) > -1) {
                return true;
            }
        }
        return false;
    }
};
var enhancePDFPreview = (0, recompose_1.compose)((0, recompose_1.withState)('status', 'setStatus', 'FETCHING'), (0, recompose_1.withState)('reference', 'setReference', undefined), (0, recompose_1.withState)('pdfUrl', 'setPdfUrl', undefined), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        var pdfUrl = "".concat(__UPLOADSERVERURL__, "/files/").concat(nextProps.revision.uuid, "?preview=true&token=").concat(nextProps.token);
        if (pdfUrl !== this.props.pdfUrl) {
            nextProps.setPdfUrl(pdfUrl);
        }
        if (nextProps.reference &&
            (nextProps.reference !== this.props.reference ||
                nextProps.revision.uuid !== this.props.revision.uuid)) {
            nextProps.setStatus('FETCHING');
            var xhr = new XMLHttpRequest();
            xhr.open('HEAD', pdfUrl);
            xhr.onreadystatechange = function () {
                if (this.readyState === 4) {
                    if (this.status === 200) {
                        ;
                        nextProps.reference.src = pdfUrl;
                        nextProps.reference.onload = function () {
                            return nextProps.setStatus('FETCHED');
                        };
                    }
                    else {
                        return nextProps.setStatus('ERROR');
                    }
                }
            };
            xhr.send();
        }
    }
}), recompose_1.pure);
exports.PDFPreview = enhancePDFPreview(function (props) {
    var pdfUrl = "".concat(__UPLOADSERVERURL__, "/files/").concat(props.revision.uuid, "?preview=true");
    if (props.status === 'ERROR') {
        return (React.createElement(GenericErrorMessage_1.default, { icon: React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle" }), title: (0, translation_1.getLocalization)('filesPreview/preview/dwg/dearSokoProUser') }, (0, translation_1.getLocalization)('filesPreview/preview/dwg/thisFileIsNotCurrentlyAvailable')));
    }
    // If Embedded PDF is not supported by IE
    if (mobile_1.isIE11 && !isSupported('AcroPDF.PDF')) {
        return (React.createElement(GenericErrorMessage_1.default, { icon: React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle" }), title: (0, translation_1.getLocalization)('filesPreview/preview/dwg/dearSokoProUser') },
            (0, translation_1.getLocalization)('filesPreview/preview/pdf/pleaseDownloadAndInstall'),
            "\u00A0",
            React.createElement("a", { href: 'https://get.adobe.com/reader/', target: '_blank' }, "Adobe Acrobat Reader"),
            "."));
    }
    // Safari
    if ((mobile_1.isSafari || mobile_1.isIE11) && props.pdfUrl) {
        return (React.createElement("embed", { src: props.pdfUrl, className: 'iframe-style pdf-view', type: "application/pdf" }));
    }
    // Firefox, Chrome, Edge
    return (React.createElement(React.Fragment, null,
        props.status === 'FETCHING' && (React.createElement("div", null,
            React.createElement(sok_ui_1.LoadingSpinner, null))),
        React.createElement("iframe", { ref: props.setReference, className: classNames('iframe-style pdf-view', props.status !== 'FETCHED' ? 'hidden' : '') },
            React.createElement(GenericErrorMessage_1.default, { icon: React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle" }), title: (0, translation_1.getLocalization)('filesPreview/preview/pdf/dearSokoProUser') }, (0, translation_1.getLocalization)('filesPreview/preview/pdf/yourBrowserDoesntSupport')))));
});
exports.default = exports.PDFPreview;
